module.exports = __webpack_public_path__ + "img/custom.a643dec.png";